import { Navigate } from "react-router-dom";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { useAuth } from "../auth/AuthProvider";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  // Wait for /auth/me to resolve before deciding — otherwise a refresh would
  // bounce an authenticated user to /login on the first paint.
  if (loading) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
